<template>
	<div
		class="rounded bg-gradient-to-r py-12 px-16 flex flex-wrap lg:flex-nowrap gap-12 md:gap-8 justify-between items-center overflow-hidden relative border border-purple-200"
		:class="backgroundColorClasses"
	>
		<div
			v-if="backgroundImage"
			class="absolute left-0 top-0 h-full w-full"
		>
			<LazyAtomImage
				v-bind="backgroundImage"
				:height="1240"
				:width="1240"
				loading="eager"
				fit="cover"
				img-class="w-full h-full object-cover"
			/>
		</div>
		<div class="flex flex-col gap-4 relative">
			<div class="flex flex-col gap-8">
				<AtomTitle
					tag="h2"
					size="4xl"
					class="text-white drop-shadow-lg"
				>
					{{ title }}
				</AtomTitle>
				<p
					:class="[
						'text-title-size-xl',
						subtitleClass ? subtitleClass : 'text-purple-100',
					]"
				>
					{{ subtitle }}
				</p>
			</div>
		</div>

		<AtomButton
			size="xl"
			:variant="buttonColor"
			:text="buttonText"
			class="relative hidden md:inline-flex text-nowrap"
			:to="to"
			:icon-left="buttonIcon"
		/>
		<AtomButton
			size="lg"
			:variant="buttonColor"
			:text="buttonText"
			class="relative md:hidden w-full text-nowrap"
			:to="to"
			:icon-left="buttonIcon"
		/>
	</div>
</template>

<script setup lang="ts">
import type { FontAwesomeIconType } from '#base/app/plugins/fontawesome';
import { ButtonVariant } from '#base/core/enums/ButtonVariantEnum';
import type { ImageType } from '#base/core/types/ImageType';
import type { UrlType } from '#base/core/types/UrlType';

const {
	backgroundImage,
	title,
	subtitle,
	subtitleClass,
	buttonText,
	buttonIcon,
	to,
	color = 'purple',
} = defineProps<{
	title: string;
	subtitle: string;
	subtitleClass?: string;
	buttonText: string;
	buttonIcon?: FontAwesomeIconType;
	to: UrlType;
	backgroundImage?: ImageType;
	color?: 'purple' | 'pink';
}>();

const backgroundColorClasses = computed(() => {
	const classes = [];

	switch (color) {
		case 'purple':
			classes.push('from-black', 'to-purple-600');
			break;
		case 'pink':
			classes.push('from-purple-500', 'to-red-300');
			break;
	}

	return classes;
});

const buttonColor = computed(() => {
	switch (color) {
		case 'pink':
			return ButtonVariant.Brand;
		default:
			return ButtonVariant.Green;
	}
});
</script>
